import { render, staticRenderFns } from "./qaanswer.vue?vue&type=template&id=310ca26a&"
import script from "./qaanswer.vue?vue&type=script&lang=js&"
export * from "./qaanswer.vue?vue&type=script&lang=js&"
import style0 from "./qaanswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports